<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <ExpressionEditor
          :component="component"
          :containers="containers"
          v-model="value.conditions"
          title="Condition"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ExpressionEditor from "../shared/ExpressionEditor.vue";

export default {
  name: "ConditionDesigner",

  components: {
    ExpressionEditor,
  },

  props: ["value", "containers", "table", "component"],
};
</script>
